import styled from "@mui/material/styles/styled";
import { MaterialDesignContent, SnackbarProvider } from "notistack";
import { memo } from "react";
import AlertDangerIcon from "./icon-old/alert-danger.svg";
import AlertInfoIcon from "./icon-old/alert-info.svg";
import AlertSuccessIcon from "./icon-old/alert-success.svg";
import AlertWarningIcon from "./icon-old/alert-warning.svg";

const StyledContent = styled(MaterialDesignContent)(() => ({
  "&.notistack-MuiContent": {
    backgroundColor: "var(--redo-colors-background-bg-primary)",
    fontWeight: 600,
    fontSize: "var(--redo-font-size-sm, 14px)",
    color: "var(--redo-colors-text-text-secondary)",
    borderRadius: "var(--border-radius-2xl)",
    display: "flex",
    minHeight: "48px",
    width: "calc(100vw - 32px)",
    maxWidth: "640px",
    padding: "var(--redo-spacing-md, 8px)",
    boxShadow:
      "0px 8px 8px -4px var(--redo-shadow-color-secondary), 0px 20px 24px -4px var(--redo-shadow-color-primary)",
    border: "1px solid var(--redo-colors-border-border-secondary)",
  },
  "&.notistack-MuiContent #notistack-snackbar": { padding: 0, flex: 1 },
  "&.notistack-MuiContent #notistack-snackbar svg": {
    marginRight: "var(--redo-spacing-md, 8px)",
    minWidth: "fit-content",
  },
  "&.notistack-MuiContent > div:last-child": {
    paddingRight: "var(--redo-spacing-md, 8px)",
  },
  "&.notistack-MuiContent > div:last-child button svg": {
    fill: "var(--redo-colors-foreground-fg-disabled)",
    color: "var(--redo-colors-foreground-fg-disabled)",
    height: "var(--redo-icon-medium-size) !important",
    width: "var(--redo-icon-medium-size) !important",
  },
}));

export const CustomSnackbarProvider = memo(
  function CustomSnackbarProvider(props: { children: React.ReactNode }) {
    return (
      <SnackbarProvider
        Components={{
          default: StyledContent,
          success: StyledContent,
          error: StyledContent,
          info: StyledContent,
          warning: StyledContent,
        }}
        iconVariant={{
          success: <AlertSuccessIcon />,
          error: <AlertDangerIcon />,
          info: <AlertInfoIcon />,
          warning: <AlertWarningIcon />,
        }}
      >
        {props.children}
      </SnackbarProvider>
    );
  },
);
